import React from 'react';
import { FaChevronRight } from 'react-icons/fa';

import DropdownButton from './DropdownButton';

function PropertyDropdownItem({ icon, text, subProperties = [], onClick, isHidden }) {
  const isDisabled = !subProperties.length;

  return (
    <DropdownButton
      isDisabled={isDisabled}
      isHidden={isHidden}
      leftIcon={icon || null}
      rightIcon={!isDisabled && FaChevronRight}
      text={text}
      onClick={onClick}
    />
  );
}

export default PropertyDropdownItem;
